const { getVisibleSousCritereEntries } = require("../shared/progress");

export default function Navbar({ getMainActifNum, setMainActifNum, getNumberFiliereActif, getNumberCritereActif, setNumberCritereActif, getNumberSousCritereActif, setNumberSousCritereActif, criteres, click, data, isDisabled, isDisabled2, Lang, triggerSave, recordNav }) {

  /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */

  const currentPeriod = data?.data?.[getNumberFiliereActif];
  const visibleEntries = getVisibleSousCritereEntries(currentPeriod)
    .filter(({ critere }) => data?.configuration !== 'Echange' || Number(critere.id) !== 50);
  const currentPositionIndex = visibleEntries.findIndex(({ critereIndex, sousCritereIndex }) => (
    critereIndex === getNumberCritereActif && sousCritereIndex === getNumberSousCritereActif
  ));

  const isBeforeCurrent = (entry) => (
    entry.critereIndex < getNumberCritereActif
    || (entry.critereIndex === getNumberCritereActif && entry.sousCritereIndex < getNumberSousCritereActif)
  );
  const isAfterCurrent = (entry) => (
    entry.critereIndex > getNumberCritereActif
    || (entry.critereIndex === getNumberCritereActif && entry.sousCritereIndex > getNumberSousCritereActif)
  );

  const previousPosition = currentPositionIndex > 0
    ? visibleEntries[currentPositionIndex - 1]
    : [...visibleEntries].reverse().find(isBeforeCurrent);
  const nextPosition = currentPositionIndex >= 0
    ? visibleEntries[currentPositionIndex + 1]
    : visibleEntries.find(isAfterCurrent);
  const isNextPayment = Number(nextPosition?.critere?.id) === 50 || Number(nextPosition?.sousCritere?.id) === 51;
  const btnSuivant = isNextPayment
    ? (Lang === "en" ? "Pay" : "Paiement")
    : (Lang === "en" ? "Next" : "Suivant");
  const nextButtonDisabled = isNextPayment ? isDisabled2 : isDisabled;

  /* --- GESTION VISIBILITÉ DU BOUTON RETOUR --- */

  const getStyleBtnRetour = () => {
    return previousPosition ? { visibility: "visible" } : { visibility: "hidden" };
  };

  /* --- GESTION VISIBILITÉ DU BOUTON SUIVANT --- */

  const getStyleBtnSuivant = () => {
    return nextPosition ? { visibility: "visible" } : { visibility: "hidden" };
  };

  const moveToPosition = (position) => {
    if (!position) return;
    setNumberCritereActif(position.critereIndex);
    setNumberSousCritereActif(position.sousCritereIndex);
  };

  // décrémenter le numéro du menu actif (revenir à la selection des sous-critères)
  const handleClickDecreGetMain = () => {
    if (recordNav) {
      recordNav();
    }
    triggerSave();
    click();
    if (getMainActifNum !== 0) {
      setMainActifNum(getMainActifNum - 1);
    }
  };

  // décrémenter le numéro du sous-critère actif (revenir aux questions précédentes)
  const handleClickDecreGetNumberActif = () => {
    if (recordNav) {
      recordNav();
    }
    triggerSave();
    moveToPosition(previousPosition);
    click();
  };

  // incrémenter le numéro du sous-critère actif (aller aux questions suivantes)
  const handleClickIncreGetNumberActif = () => {
    if (recordNav) {
      recordNav();
    }
    triggerSave();
    moveToPosition(nextPosition);
    click();
  };

  /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */

  return (
    <nav>
      <button onClick={handleClickDecreGetNumberActif} style={getStyleBtnRetour()} disabled={isDisabled}>{Lang === "en" ? "Back" : "Retour"}</button>
      <button className="BtnChecklist" onClick={handleClickDecreGetMain} disabled={isDisabled}>{Lang === "en" ? "Home" : "Menu Principal"}</button>
      <button onClick={handleClickIncreGetNumberActif} style={getStyleBtnSuivant()} disabled={nextButtonDisabled}>{btnSuivant}</button>
    </nav>
  );
}
